export default "__VITE_ASSET__ap5HWQPE__"